<section class="bank-integrations-panel" [attr.aria-label]="'Integraciones de ' + bankName">
  <header class="bank-integrations-header">
    <div>
      <strong>{{ bankName }} · Integraciones</strong>
      <span>{{ integrations.length }} configuradas</span>
    </div>
    <app-button variant="outlined" size="small" (clicked)="add.emit()">
      <i button-icon class="fa-solid fa-plus"></i>
      Agregar
    </app-button>
  </header>

  @if (integrations.length) {
    <div class="integration-list">
      @for (integration of integrations; track integration.id) {
        <article class="integration-item">
          <div class="integration-main">
            <span class="integration-icon"><i class="fa-solid fa-plug"></i></span>
            <div>
              <strong>{{ integration.tipoProveedor }}</strong>
              <span>{{ integration.tipoAutenticacion }} · {{ integration.urlBase }}</span>
            </div>
          </div>

          <span
            class="status"
            [class.active]="integration.estaActivo"
            [class.inactive]="!integration.estaActivo"
            [class.review]="integration.estadoUltimaPrueba === 'PENDIENTE'"
          >
            <i></i>
            {{
              integration.estaActivo
                ? integration.estadoUltimaPrueba === 'PENDIENTE'
                  ? 'En revisión'
                  : 'Activo'
                : 'Inactivo'
            }}
          </span>

          <span class="integration-date">
            {{ integration.ultimaSincronizacion || 'Sin sincronización' }}
          </span>

          <div class="integration-actions">
            <app-button
              variant="text"
              size="small"
              [loading]="testingId === integration.id"
              ariaLabel="Probar conexión"
              (clicked)="test.emit(integration)"
            >
              <i button-icon class="fa-solid fa-plug"></i>
              Probar
            </app-button>
            <app-button
              variant="text"
              size="small"
              shape="circle"
              ariaLabel="Editar integración"
              (clicked)="edit.emit(integration)"
            >
              <i button-icon class="fa-solid fa-pen"></i>
            </app-button>
            <app-button
              variant="text"
              size="small"
              shape="circle"
              [ariaLabel]="
                integration.estaActivo ? 'Desactivar integración' : 'Activar integración'
              "
              [color]="integration.estaActivo ? 'blue' : 'red'"
              [hoverColor]="integration.estaActivo ? 'blue' : 'red'"
              [hoverBorder]="true"
              (clicked)="toggle.emit(integration)"
            >
              <i
                button-icon
                class="fa-solid"
                [class.fa-toggle-on]="integration.estaActivo"
                [class.fa-toggle-off]="!integration.estaActivo"
              ></i>
            </app-button>
          </div>
        </article>
      }
    </div>
  } @else {
    <div class="integration-empty">
      <i class="fa-solid fa-plug-circle-xmark"></i>
      <span>Banco sin integración configurada.</span>
      <app-button variant="text" size="small" (clicked)="add.emit()">Configurar ahora</app-button>
    </div>
  }
</section>
